/*
 * This file is deprecated since v5.6.0 and will be removed in v6.0.0. Use `validationMixin.m.js` mixin instead 
	and create required components using this mixin.
 */
import ActionField from '../actionField/actionField.m.js';

export default class ActionFieldWithValidation extends ActionField {
	constructor(...args) {
		const _ = super(...args);
		return _;
	}

	setup() {
		super.setup();
		if (!this._isCreated) {
			this._validationMessageText = 'Invalid';
			this._validationMessageType = 'zs-error';
			this.syncProp('validationMessageText');
			this.syncProp('validationMessageType');
			this._isCreated = true;
		}
	}
	static get observedAttributes() {
		return super.observedAttributes.concat(['validation-message-text', 'validation-message-type']);
	}
	oninvalid(event) {
		super.oninvalid(event);
		if (this.validationMessageType == 'zs-warning') {
			this.classList.add('zs-warning');
		} else if (this.validationMessageType == 'zs-info') {
			this.classList.add('zs-info');
		}
		this.showMessage();
	}
	get messageElement() {
		return this.root.querySelector('.zs-message');
	}
	hideMessage() {
		if (this.messageElement) {
			this.messageElement.setAttribute('style', 'display:none');
		}
		this.classList.remove('zs-warning');
		this.classList.remove('zs-info');
	}
	showMessage(message, type) {
		message = message || this.validationMessageText;
		type = type || this.validationMessageType;
		if (!this.messageElement) {
			let el = document.createElement('p');
			el.classList.add('zs-message');
			this.inputElement.parentNode.appendChild(el);
		}
		this.messageElement.innerHTML = message;
		this.messageElement.setAttribute('class', 'zs-message ' + type);
		this.messageElement.setAttribute('style', 'display:block');

	}
	oninput(event) {
		super.oninput(event);
		if (!this.invalid) {
			this.hideMessage();
		}
	}
}

// Fix tooltip positioning
function fixedPositioning() {
	this.style.position = 'absolute';
}